import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 71DAA530-D02E-45D9-84AB-68CE1CD1E44E
 * name tablet-dashboard
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/tablet-dashboard.svg
 * tags
 * - Device / Tech 
 */
export const TabletDashboardIcon = createSvgIcon(<><path d="M19,18H5V6H19M21,4H3C1.89,4 1,4.89 1,6V18A2,2 0 0,0 3,20H21A2,2 0 0,0 23,18V6C23,4.89 22.1,4 21,4M7,8H13V13H7V8M14,8H17V10H14V8M17,11V16H14V11H17M7,14H13V16H7V14Z" /></>, 'TabletDashboardIcon');
export default TabletDashboardIcon